#import "../../../../../common/graphql/RatingEntityResultFields.graphql"
mutation RatingSupplierCreate($input: RatingSupplierCreateInput!) {
  ratingSupplierCreate(input: $input) {
    ratingEntity {
      ratingResults {
        ...RatingEntityResultFields
      }
    }
  }
}
